var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFinishedStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    fill: "white",
    stroke: "#DFDFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3221 16.1523V14.1309H18.1169H15.9116V16.1523C15.9116 20.115 15.0861 22.6302 14.7314 23.508L18.1169 23.5411L21.5296 23.5745C21.1663 22.6973 20.3221 20.1769 20.3221 16.1523Z",
    fill: "#B4B4B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3224 16.1523V14.1309H18.1172V23.5411L21.5299 23.5745C21.1667 22.6973 20.3224 20.1769 20.3224 16.1523Z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7913 10.5195C24.7052 10.2754 24.4755 10.0977 24.1984 10.0609L20.4512 9.56145L18.7757 6.34545C18.6523 6.11513 18.3845 6 18.1167 6C17.849 6 17.5812 6.11513 17.4577 6.34545L15.7823 9.56145L12.0351 10.0609C11.758 10.0977 11.5283 10.2754 11.4421 10.5195C11.3559 10.763 11.4277 11.0308 11.6288 11.2098L14.3394 13.6327L13.6991 17.0532C13.6517 17.3059 13.7651 17.5612 13.992 17.7119C14.2174 17.8639 14.5203 17.8823 14.7658 17.7632L18.1167 16.1484L21.4677 17.7632C21.7233 17.8866 22.023 17.8581 22.2415 17.7119C22.4684 17.5612 22.5818 17.3058 22.5344 17.0532L21.8941 13.6327L24.6047 11.2098C24.8057 11.0308 24.8775 10.763 24.7913 10.5195Z",
    fill: "#DEDEDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.242 17.7119C22.4688 17.5612 22.5822 17.3059 22.5349 17.0532L21.8946 13.6327L24.6052 11.2098C24.8062 11.0308 24.878 10.763 24.7919 10.5195C24.7057 10.2754 24.476 10.0977 24.1989 10.0609L20.4517 9.56145L18.7762 6.34545C18.6527 6.11513 18.385 6 18.1172 6V16.1484L21.4681 17.7632C21.7238 17.8866 22.0235 17.8581 22.242 17.7119Z",
    fill: "#BBBBBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7599 22.9704L18.3494 21.6227C18.2733 21.5997 18.195 21.5823 18.1168 21.5823C18.0385 21.5823 17.9603 21.5997 17.8842 21.6227L13.4737 22.9704C13.1736 23.0619 12.9712 23.3192 12.9712 23.6094V28.3262H18.1168H23.2624V23.6094C23.2624 23.3192 23.0599 23.0619 22.7599 22.9704Z",
    fill: "#D4D4D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2623 23.6094C23.2623 23.3192 23.0599 23.0619 22.7598 22.9704L18.3493 21.6227C18.2732 21.5997 18.195 21.5823 18.1167 21.5823V28.3262H23.2623V23.6094Z",
    fill: "#BBBBBB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9974 27.6523H18.1167H12.2361C11.8298 27.6523 11.501 27.9537 11.501 28.3262C11.501 28.6986 11.8298 29 12.2361 29H18.1167H23.9974C24.4037 29 24.7325 28.6986 24.7325 28.3262C24.7325 27.9537 24.4037 27.6523 23.9974 27.6523Z",
    fill: "#BBBBBB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.733 28.3262C24.733 27.9537 24.4042 27.6523 23.9979 27.6523H18.1172V29H23.9979C24.4042 29 24.733 28.6986 24.733 28.3262Z",
    fill: "#A0A0A0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.587 24.957H18.1169H16.6467C16.2404 24.957 15.9116 25.2584 15.9116 25.6309C15.9116 26.0033 16.2404 26.3047 16.6467 26.3047H18.1169H19.587C19.9934 26.3047 20.3221 26.0033 20.3221 25.6309C20.3221 25.2584 19.9934 24.957 19.587 24.957Z",
    fill: "#BBBBBB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3224 25.6309C20.3224 25.2584 19.9937 24.957 19.5874 24.957H18.1172V26.3047H19.5874C19.9937 26.3047 20.3224 26.0033 20.3224 25.6309Z",
    fill: "#A0A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFinishedStep);
export default __webpack_public_path__ + "static/media/not_finished_step.66a69e276fb47b8b18e287e010ba3b68.svg";
export { ForwardRef as ReactComponent };